import { FlagId } from '../../../models/communication.types';
import ActionsMenu from '../../ActionsMenu/ActionsMenu.component';
import MessageFlag from '../MessageFlag.component';
import { ReactComponent as ActionMenuFlag } from '../../../assets/icons/action-menu-flag.svg';
import ClearIcon from '@mui/icons-material/Clear';
import { handleRemoveMessageFlag, handleSetMessageFlag } from './utils';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { mailboxActions } from '../../../reducers/mailboxReducer/mailboxSlice';
import { useLayoutContext } from '../../../Context/Layout.context';
import { fillBlue } from '../../../utils/contrastSvgAttributes';

interface AssignFlagProps {
  flagId: FlagId | null;
}

export const AssignFlag: React.FC<AssignFlagProps> = ({ flagId }) => {
  const dispatch = useDispatch();
  const activeMessageId = useSelector((state: RootState) => state.mailbox.activeMessageId);

  const { openAlert } = useLayoutContext();

  const handleUpdateCurrentMessageFlag = (flag: FlagId | null) => {
    dispatch(mailboxActions.updateCurrentMessageFlag(flag));
    if (activeMessageId) {
      dispatch(mailboxActions.setMessageToUpdateFlag({ messageId: activeMessageId, flag: flag }));
    }
  };

  const handleMessageFlagAction = (flag: FlagId) => {
    handleSetMessageFlag(activeMessageId, flag, handleUpdateCurrentMessageFlag, openAlert);
  };

  const actionItems = [
    {
      text: 'Oznacz jako ważną',
      icon: <MessageFlag flagId={FlagId.Green} />,
      onClick: () => {
        handleMessageFlagAction(FlagId.Green);
      },
    },
    {
      text: 'Oznacz jako bardzo ważną',
      icon: <MessageFlag flagId={FlagId.Yellow} />,
      onClick: () => {
        handleMessageFlagAction(FlagId.Yellow);
      },
    },
    {
      text: 'Oznacz jako pilną',
      icon: <MessageFlag flagId={FlagId.Red} />,
      onClick: () => {
        handleMessageFlagAction(FlagId.Red);
      },
    },
    {
      text: 'Usuń oznaczenie',
      icon: <ClearIcon />,
      onClick: () => {
        handleRemoveMessageFlag(activeMessageId, handleUpdateCurrentMessageFlag, openAlert);
      },
    },
  ];

  return (
    <ActionsMenu
      menuItems={actionItems}
      anchorOrigin={{ horizontal: 260, vertical: 'center' }}
      icon={
        flagId !== null ? (
          <MessageFlag flagId={flagId} />
        ) : (
          <div>
            <ActionMenuFlag
              style={{ color: '#3C419A', cursor: 'pointer', position: 'relative', left: '5px', top: '2px' }}
              aria-controls="action-menu"
              stroke={fillBlue}
              aria-haspopup="true"
              aria-hidden="false"
              title="flaga w menu akcji"
            />
          </div>
        )
      }
    />
  );
};
